import { ENRICHMENT_CATEGORY_TYPE_CUSTOM } from 'common-data-handling';
import React from 'react';
import ActionButton from '../../../../../elements/ActionButton/ActionButton';
import { useEnrichmentQuestions } from '../../../../../../data/hooks/enrichments/useEnrichmentQuestions';

export function CustomEnrichment(props) {
    let { i18n, event } = props,
        ecat = _(event.enrichment_categories)
            .values()
            .find((ecat) => ecat.category == ENRICHMENT_CATEGORY_TYPE_CUSTOM),
        openQuestions = useEnrichmentQuestions(event.id, {
            filter: (q) => q.question.category == ENRICHMENT_CATEGORY_TYPE_CUSTOM && !q.answer.length,
        });

    const hasOpenQuestions = ecat?.open_count || openQuestions.length > 0;

    if (!ecat) return null;
    if (!hasOpenQuestions) return null;

    return (
        <ActionButton
            href={'./enrich/' + ecat.category}
            style={{
                textTransform: 'capitalize',
            }}
            secondary
            next
            small>
            {ecat.label || event.settings.custom_enrich_label || i18n['label.custom_enrichment']}
        </ActionButton>
    );
}
